document.addEventListener('DOMContentLoaded', function() {
    iniciarApp();
});

function iniciarApp() {
    const esNavegacionInterna = document.referrer.includes(window.location.host);
    const yaVistoEnEstaSesion = sessionStorage.getItem('anuncioVisto');

    // REGLA: Si vengo de fuera (Google, directo) Y no lo he visto en esta pestaña, lo muestro.
    // Si vengo de /sistemas, document.referrer tendrá mi propio dominio y NO se mostrará.
    if (!esNavegacionInterna && !yaVistoEnEstaSesion) {
        mostrarAnuncio();
    }
}

function mostrarAnuncio() {
    const anuncioModal = document.querySelector('#modal-promocion');
    const btnCerrar = document.querySelector('#cerrar-anuncio');

    if(anuncioModal) {
        setTimeout(() => {
            anuncioModal.classList.add('anuncio-modal--visible');
            document.body.classList.add('fijar-body');
            // Marcamos para que no salga al volver de /sistemas
            sessionStorage.setItem('anuncioVisto', 'true');
        }, 3000);

        if(btnCerrar) btnCerrar.addEventListener('click', cerrarModal);

        anuncioModal.addEventListener('click', (e) => {
            if(e.target.id === 'modal-promocion') cerrarModal();
        });
    }
}

function cerrarModal() {
    const anuncioModal = document.querySelector('#modal-promocion');
    if(anuncioModal) {
        anuncioModal.classList.remove('anuncio-modal--visible');
        document.body.classList.remove('fijar-body');
    }
}